import { useLoaderData } from 'react-router';
import { EppMaintenanceAdmin } from '../../../../../components/EppMaintenance/EppMaintenanceAdmin.js';
import type { DeviceSubPostChangeRequestLoaderResponse } from '../../../../../common/loaders.js';

export const DeviceSupportRequestPath = () => {
  const { companyInfo, hasPendingActions, subscription } = useLoaderData() as DeviceSubPostChangeRequestLoaderResponse;

  return (
    <EppMaintenanceAdmin subscription={subscription} companyInfo={companyInfo} hasPendingActions={hasPendingActions} />
  );
};
